
import { Component, Vue, Prop } from 'vue-property-decorator'

import { CSV_HEADERS } from '../types/dotationOrderForm'
import { CsvHeader, DotationCsvRow } from '../utils/csvImport'

@Component({ name: 'CsvDataTable' })
export default class CsvDataTable extends Vue {
  @Prop({ required: true }) readonly data!: DotationCsvRow[]

  private currentPage = 1
  private readonly pageSize = 25
  private readonly headers: readonly CsvHeader[] = CSV_HEADERS

  private readonly headerCellStyle = {
    background: '#f5f7fa',
    color: '#606266',
    fontWeight: 600
  }

  get paginatedData(): DotationCsvRow[] {
    const start = (this.currentPage - 1) * this.pageSize
    return this.data.slice(start, start + this.pageSize)
  }

  headerLabel(header: CsvHeader): string {
    return String(this.$t(`newDotationOrder.entry.csvTable.headers.${header}`))
  }

  fieldError(row: DotationCsvRow, header: CsvHeader): string {
    return row.fieldErrors[header] || ''
  }

  getCellStyle({ row, column }: { row: DotationCsvRow; column: { property?: string } }): Record<string, string> {
    if (column.property && this.fieldError(row, column.property as CsvHeader)) {
      return { backgroundColor: '#FFF5F5' }
    }
    return {}
  }

  getRowClass({ row }: { row: DotationCsvRow }): string {
    return Object.keys(row.fieldErrors).length > 0 ? 'csv-table__row--invalid' : ''
  }

  handleCurrentChange(page: number): void {
    this.currentPage = page
  }
}
